import { Preferences } from "@capacitor/preferences";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

type Flag = "OpenedCareMomentsIntro";

export default function useFlag(props: { name: Flag }) {
  const queryClient = useQueryClient();
  const { data: isFlagged } = useQuery({
    queryKey: ["flag", props.name],
    queryFn: async () => {
      const { value } = await Preferences.get({ key: `flag:${props.name}` });
      return value !== null;
    },
  });

  const { mutate: markAsFlagged } = useMutation({
    mutationFn: async () => {
      await Preferences.set({ key: `flag:${props.name}`, value: "1" });
      await queryClient.invalidateQueries(["flag", props.name]);
    },
  });

  return { isFlagged: isFlagged ?? false, markAsFlagged };
}
